export default __webpack_public_path__ + "static/carEngine-c0b0d2c35898bf0e9da92f25ed9db275.png";